module.exports = __webpack_public_path__ + "img/image_2.543ab3c3.png";